import { SellingPlan } from './selling-plan'
import { SellingPlanGroup } from './selling-plan-group'
import { widgetState } from '../store/customizations/index'
import { getProduct } from '../store/product/getters'

export const buyOnceId = 'buy-once'
const buyOnceSellingPlanId = 0

export const shouldShowBuyOnce = () => {
  return !getProduct().requiresSellingPlan
}

export const isBuyOnceId = (id: string): boolean => {
  if (!id) {
    return false
  }
  return id.toLowerCase() === buyOnceId
}

export const isBuyOneSellingPlan = (id: number): boolean => {
  return id === buyOnceSellingPlanId
}

export const getBuyOnceAsSellingPlanGroup = (): SellingPlanGroup => {
  return {
    id: buyOnceId,
    name: widgetState.customizations.buyOnceText,
    options: [],
    sellingPlans: []
  }
}

export const getBuyOnceAsSellingPlan = (): SellingPlan => {
  return {
    id: buyOnceSellingPlanId,
    name: widgetState.customizations.buyOnceText,
    options: [],
    description: '',
    priceAdjustments: []
  }
}
